<template>
<div>
    <Breadcrumbs main="Project" title="Project Create" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-12">
                <px-card>
                    <div slot="with-padding">
                        <div class="form theme-form">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>Project Title <span style="color: red;">*</span></label>
                                        <input class="form-control" type="text" placeholder="Enter project title" v-model="project.title">
                                    </div>
                                </div>
                                <!-- <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Client <span><button class="btn-success ml-3">Add New</button></span></label>
                                        <select class="form-control digits" v-model="project.client">
                                            <option v-for="(client, index) in clients" :key="index">{{ client }}</option>
                                        </select>
                                    </div>
                                </div> -->
                            </div>

                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Project Type</label>
                                        <select class="form-control digits" v-model="projectCategory">
                                            <option v-for="(type, index) in project_type" :key="index" :value="type">{{ type.title }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Priority</label>
                                        <select class="form-control digits" v-model="project.priority">
                                            <option v-for="(priority, index) in priorities" :key="index">{{ priority }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Status</label>
                                        <select class="form-control digits" v-model="project.status">
                                            <option v-for="(status, index) in statuses" :key="index">{{ status }}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label>Employee</label>
                                        <multiselect v-model="assignedEmployee" tag-placeholder="Add Emloyee" placeholder="Search employee" label="user_name" :max="formattedEmloyee.length" track-by="id" :options="formattedEmloyee" :multiple="true" :taggable="true"></multiselect>
                                    </div>
                                </div>
                                <!-- <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Client</label>
                                        <v-select class="custom-vue-select" :options="formattedClient" :reduce="client => client.id" label="company_name" v-model="project.client_ids" placeholder="Select a client"></v-select>
                                    </div>
                                </div> -->
                                <!-- <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Clients</label>
                                        <multiselect v-model="assignedClient" tag-placeholder="Add Client" placeholder="Search" label="company_name" :max="formattedClient.length" track-by="id" :options="formattedClient" :multiple="true" :taggable="true"></multiselect>
                                    </div>
                                </div> -->
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Company <span style="color: red;">*</span></label>
                                        <select class="form-control digits" v-model="project.company" style="height:44px">
                                            <option :value="null" :disabled="!project.company">-- Select Company --</option>
                                            <option v-for="(company, index) in companies" :key="index" :value="company.id">{{ company.name }}</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-sm-6" v-if="project.company">
                                    <div class="form-group">
                                        <label>Client</label>
                                        <v-select class="custom-vue-select" :options="formattedClient" :reduce="client => client.id" label="company_name" v-model="project.client_ids" placeholder="Select a client"></v-select>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Start Date <span style="color: red;">*</span></label>
                                        <datepicker placeholder="Select a date" input-class="datepicker-here form-control digits" ref="datepicker" v-model="project.start_date"></datepicker>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Deadline</label>
                                        <datepicker placeholder="Select a date" input-class="datepicker-here form-control digits" ref="datepickerend" :disabled-dates="endDateDisabled" v-model="project.deadline"></datepicker>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Upload project file</label>
                                        <b-form-file :multiple="true" placeholder="Choose files  or drop them here..." drop-placeholder="Drop file here..." @change="uploadFile"></b-form-file>
                                    </div>
                                </div>
                            </div>
                             <div class="row">
                                <div class="col-sm-12">
                                    <hr style="margin: 25px 0px 25px 0px; border:1px solid #000000">
                                </div>
                             </div>

                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>PO Value</label>
                                        <input class="form-control" type="number" placeholder="Enter PO Value" v-model="project.po_value">
                                        <small class="text-danger" v-if="errors.po_value">{{ errors.po_value }}</small>
                                    </div>
                                </div>
                                 <div class="col-sm-6">
                                    <div class="form-group">
                                        <label>Budget</label>
                                        <input class="form-control" type="number" placeholder="Enter project budget" v-model="project.budget">
                                        <small class="text-danger" v-if="errors.budget">{{ errors.budget }}</small>
                                    </div>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>Vat Type</label>
                                        <select class="form-control digits" v-model="project.val_type">
                                            <option v-for="(type, index) in val_type" :key="index" :value="type.value">{{ type.title }}</option>
                                        </select>
                                        <small class="text-danger" v-if="errors.val_type">{{ errors.val_type }}</small>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>PO Vat</label>
                                        <input class="form-control" type="number" placeholder="Enter PO Vat" v-model="project.po_vat">
                                        <small class="text-danger" v-if="errors.po_vat">{{ errors.po_vat }}</small>
                                    </div>
                                </div>

                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>PO Vat Amount</label>
                                        <input class="form-control" type="number" placeholder="PO Vat Amount" v-model="vatAmount" disabled>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>AIT Type</label>
                                        <select class="form-control digits" v-model="project.ait_type">
                                            <option v-for="(type, index) in val_type" :key="index" :value="type.value">{{ type.title }}</option>
                                        </select>
                                        <small class="text-danger" v-if="errors.ait_type">{{ errors.ait_type }}</small>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>PO AIT</label>
                                        <input class="form-control" type="number" placeholder="Enter PO AIT" v-model="project.po_ait">
                                        <small class="text-danger" v-if="errors.po_ait">{{ errors.po_ait }}</small>
                                    </div>
                                </div>

                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label>PO AIT Amount</label>
                                        <input class="form-control" type="number" placeholder="PO AIT Amount" v-model="aitAmount" disabled>

                                    </div>
                                </div>

                            </div>
                           

                            <div class="row">
                                <div class="col">
                                    <div class="form-group">
                                        <label>Project Details</label>
                                        <textarea class="form-control" id="exampleFormControlTextarea4" placeholder="Enter project details..." rows="4" v-model="project.details"></textarea>
                                    </div>
                                </div>
                            </div>

                            <!-- {{ subtotal }} -->

                            <div class="row">
                                <div class="col">
                                    <div class="form-group mb-0">
                                        <button @click="validateProjectCategory" class="btn btn-success mr-3">Create</button>
                                        <router-link to="/project/list">
                                            <button class="btn btn-danger" href="#">Go Back</button>
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </px-card>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->
</div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import moment from "moment";
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import {
    mapState
} from 'vuex';
import Multiselect from 'vue-multiselect';
import {
    computed
} from "vue";
export default {
    components: {
        vueDropzone: vue2Dropzone,
        Datepicker,
        Multiselect,
        'v-select': vSelect
    },

    data() {
        return {
            project: {
                title: '',
                details: null,
                category: '',
                start_date: null,
                deadline: null,
                priority: 'HIGH',
                status: 'PENDING',
                project_attachment: null,
                po_value: null,
                po_vat: null,
                po_ait: null,
                budget: null,
                val_type: 'inclusive',
                client_ids: '',
                ait_type: 'inclusive',
                company: ''
            },
            isButtonDisabled: false,
            calculatedDate: null,
            assignedEmployee: [],
            assignedClient: [],
            employee_ids: [],
            // client_ids: [],
            projectCategory: null,
            // project_type: [{
            //         id: 1,
            //         title: 'project',
            //     },
            //     {
            //         id: 2,
            //         title: 'others'
            //     }
            // ],

            priorities: ['HIGH', 'MEDIUM', 'LOW'],
            statuses: ['PENDING', 'APPROVED', 'WORKING', 'COMPLETED','ARCHIVED','PAUSED','POSTPONED','ARCHIVED'],
            val_type: [{
                    id: 1,
                    value: "inclusive",
                    title: "Inclusive",
                },
                {
                    id: 2,
                    value: "exclusive",
                    title: "Exclusive",
                }
            ],
            errors: {
                po_value: '',
                po_vat: '',
                po_ait: '',
                budget: '',
                val_type: '',
                ait_type: ''
            },

            subtotal: computed(() => {

                const total = Number(this.project.po_value);
                const discount = Number(this.project.discount || 0);

                // Case 1: both VAT and TAX are inclusive → just apply discount to total
                if (this.project.val_type === 'inclusive' && this.project.ait_type === 'inclusive') {
                    const discounted = total - (total * discount / 100);
                    return Math.round((discounted + Number.EPSILON) * 100) / 100;
                }

                // Case 2: Exclusive taxes → add them first
                let calculated = total;

                if (this.project.val_type === 'exclusive') {
                    calculated += this.vatAmount;
                }

                if (this.project.ait_type === 'exclusive') {
                    calculated += this.aitAmount;
                }

                // Apply discount to final calculated total
                const discounted = calculated - (calculated * discount / 100);
                return Math.round((discounted + Number.EPSILON) * 100) / 100;
            }),

            aitAmount: computed(() => {
                if (this.project ?.po_ait && this.project ?.ait_type && this.project ?.po_value) {
                    const po_vat = Number(this.project.po_ait);
                    return Math.round((this.basePrice * po_vat / 100 + Number.EPSILON) * 100) / 100;
                }

                return 0;
            }),

            vatAmount: computed(() => {
                if (this.project ?.po_vat && this.project ?.val_type && this.project ?.po_value) {
                    const po_vat = Number(this.project.po_vat);
                    return Math.round((this.basePrice * po_vat / 100 + Number.EPSILON) * 100) / 100;
                }

                return 0;
            }),

            basePrice: computed(() => {
                if (!this.project ?.po_value || !this.project ?.val_type || !this.project ?.ait_type) return 0;

                const total = Number(this.project.po_value);
                const po_vat = Number(this.project.po_vat || 0);
                const po_ait = Number(this.project.po_ait || 0);

                if (this.project.val_type === 'inclusive' && this.project.ait_type === 'inclusive') {
                    const divisor = 1 + (po_vat + po_ait) / 100;
                    const base = total / divisor;
                    return Math.round((base + Number.EPSILON) * 100) / 100;
                }

                let divisor = 1;
                if (this.project.val_type === 'inclusive') {
                    divisor += po_vat / 100;
                }
                if (this.project.ait_type === 'inclusive') {
                    divisor += po_ait / 100;
                }

                const base = total / divisor;
                return Math.round((base + Number.EPSILON) * 100) / 100;
            }),

        };
    },

    mounted() {
        this.$store.dispatch("projectType/fetchProjectType");
        this.$store.dispatch("employee/fetchEmployeeList");
        // this.$store.dispatch("client/fetchClient_without_pg")
        this.$store.dispatch("client/fetchCompany")
    },

    computed: {
        ...mapState({
            project_type: state => state.projectType.projectType,
            user_list: state => state.employee.employee_list,
            clients: state => state.client.client_by_company,
            companies: state => state.client.company

        }),

        endDateDisabled() {
            return {
                to: this.project.start_date ? new Date(this.project.start_date) : null
            };
        },

        formattedEmloyee() {
            return [
                ...this.user_list.map(user => ({
                    id: user.id,
                    user_name: user.user_name
                }))
            ];
        },

        formattedClient() {
            return [
                ...this.clients.map(client => ({
                    id: client.user.id,
                    company_name: client.company_name
                }))
            ];
        },
    },

    watch: {
        'project.start_date': function (newStartDate, oldStartDate) {
            if (this.project.deadline) {
                this.project.deadline = null
            }
        },

        'project.company'(newVal, oldVal) {
            this.$store.dispatch("client/fetchClient_ByCompany", newVal)
            this.project.client_ids = ''
        }
    },

    methods: {
        uploadFile(e) {
            this.project.project_attachment = e.target.files[0]
        },

        validateProjectCategory() {
            this.errors = {
                po_value: '',
                po_vat: '',
                po_ait: '',
                budget: '',
                val_type: '',
            };

            let valid = true;

            if (this.projectCategory ?.title === 'PROJECT') {
                if (!this.project.po_value) {
                    this.errors.po_value = 'PO Value is required.';
                    valid = false;
                }
                if (!this.project.po_vat) {
                    this.errors.po_vat = 'PO VAT is required.';
                    valid = false;
                }
                if (!this.project.po_ait) {
                    this.errors.po_ait = 'PO AIT is required.';
                    valid = false;
                }
                if (!this.project.budget) {
                    this.errors.budget = 'Budget is required.';
                    valid = false;
                }
                if (!this.project.val_type) {
                    this.errors.val_type = 'Vat type is required.';
                    valid = false;
                }
                if (!this.project.ait_type) {
                    this.errors.ait_type = 'AIT type is required.';
                    valid = false;
                }
            }

            if (valid) {
                this.onSubmit();
            }
        },

        onSubmit() {
            // console.log('here')
            if (this.project.start_date !== null) {
                this.project.start_date = moment(String(this.project.start_date)).format("YYYY-MM-DD");
            }
            if (this.project.deadline !== null) {
                this.project.deadline = moment(String(this.project.deadline)).format("YYYY-MM-DD");
            }

            // this.project.title = this.project.title.trim() ? this.project.title : null;
            this.project.category = this.projectCategory ?.id;
            this.assignedEmployee.map(item => this.employee_ids.push(item.id));
            // this.assignedClient.map(item => this.client_ids.push(item.id));

            if (this.project.title && this.project.start_date && this.project.company) {
                this.$store.dispatch("project/addProject", {
                    project: this.project,
                    //  client:this.client_ids, 
                    employee: this.employee_ids
                }).then(response => {
                    if (response.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.project.title = null,
                            this.project.details = null,
                            this.project.start_date = null,
                            this.project.deadline = null,
                            this.project.priority = 'HIGH',
                            this.project.status = 'APPROVED',
                            this.project.project_attachment = null
                        this.project.po_value = null
                        this.project.client_ids = null
                        this.project.po_vat = null
                        this.project.po_ait = null
                        this.project.budget = null
                        this.project.val_type = null
                        this.project.ait_type = null
                        this.assignedEmployee = []
                        this.assignedClient = []
                        this.client_ids = []
                        this.employee_ids = []

                        setTimeout(() => {
                            this.$router.push(`/project/list`)
                        }, 2000)
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
            } else {
                this.project.title = '',
                    this.project.start_date = null,
                    this.project.company = null,
                    Swal.fire({
                        title: "Error!",
                        text: 'You must enter Project Title, Start Date & Company',
                        icon: "error"
                    });
            }
        }
    }
};
</script>
